// extracted by mini-css-extract-plugin
export default {"cls1":"li6dvQff7zAvILS5UG5r","cls2":"CNIUbeuaFszGxwIqKWQj li6dvQff7zAvILS5UG5r"};